import { loadStorage, removeStorage, saveStorage } from '@/utils/cache'
import { SIMULATED_KEY } from '@/constant/cache-key'

function isLoginByBo() {
  return !!loadStorage(SIMULATED_KEY)
}

function getSimulated() {
  return loadStorage(SIMULATED_KEY)
}

function setSimulated(token: string) {
  saveStorage(SIMULATED_KEY, token)
}

function clearSimulated() {
  removeStorage(SIMULATED_KEY)
}

export { isLoginByBo, getSimulated, setSimulated, clearSimulated }
